import React from 'react';
import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';
import { TransportTypeCount } from '../api/types';

interface Props {
    transportTypes?: TransportTypeCount[];
    isLoading?: boolean;
    selectedYear: number | null;
}

export const Totalleasingtable: React.FC<Props> = ({
    transportTypes,
    isLoading = false,
    selectedYear,
}) => {
    const { t, i18n } = useTranslation();

    if (!transportTypes) return null;

    return (
        <div className={styles.container}>
            <div className={styles.title}>
                {t('Общие данные')} {selectedYear ? `за ${selectedYear} год` : ''}
            </div>
            <div className={styles.tableWrapper}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>Техника</th>
                            <th>Кол-во</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transportTypes.map((item, index) => (
                            <tr key={index}>
                                <td>{i18n.language === 'ky' ? item.transportTypeNameKy : item.transportTypeNameRu}</td>
                                <td>{item.totalCount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
